class AnnouncementBarDismiss extends HTMLElement {
  #button = null;
  #storageKey = '';
  #handleDismiss = () => {
    const section = this.closest('.shopify-section');
    if (!section) return;

    if (typeof Shopify === 'undefined' || !Shopify.designMode) {
      try {
        sessionStorage.setItem(this.#storageKey, 'true');
      } catch (_) {}
    }

    section.setAttribute('hidden', '');
    document.querySelector('header-component')?.updateHeaderOffsetHeight?.();
  };

  connectedCallback() {
    this.#storageKey = this.dataset.storageKey || '';
    this.#button = this.querySelector('[data-ref="announcement-dismiss"]');

    if (!this.#storageKey || !this.#button) return;

    this.#button.addEventListener('click', this.#handleDismiss);
  }

  disconnectedCallback() {
    this.#button?.removeEventListener('click', this.#handleDismiss);
  }
}

if (!customElements.get('announcement-bar-dismiss')) {
  customElements.define('announcement-bar-dismiss', AnnouncementBarDismiss);
}
